import { createFileRoute, redirect } from '@tanstack/react-router';

// The Columns crumb links here; it lands on the first Columns page.
export const Route = createFileRoute('/columns/')({
  beforeLoad: () => {
    throw redirect({ to: '/columns/structured-configuration' });
  },
});
